export default import.meta.ROLLDOWN_FILE_URL_z8IqaDpT53LmDJcH$tHz3g